import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalMailSettingsRoute: InvariantJiraRoute = {
	name: 'global-mail-settings',
	path: '/secure/admin/global-mail-settings',
	exact: true,
};
